import React from "react";
import { Link } from "react-router-dom";

import CommentListItem from "./CommentListItem";

import "../css/comment-list.css";

export default function CommentList(props) {
  const comments = props.comments
  console.log(comments);

  return (
    <div className='comment-list'>
      {comments.map(comment => {
        return (<CommentListItem key={comment.id} comment={comment}/>);
      })}
    </div>
  )
}